import { withStyles, WithStyles } from '@material-ui/core/styles'
import createStyles from '@material-ui/core/styles/createStyles'
import React from 'react'
import { useTranslation } from 'react-i18next'

const styles = () =>
  createStyles({
    text: {
      fontSize: 13,
    },
  })

interface IProps extends WithStyles<typeof styles> {
  tripCount: number
}

/*
!!! Warning !!! : do not use Material-UI elements in the popup (for example, Typography).
Otherwise, you risk creating class names collisions and break the overall style
of the application.
*/

const OriginPopupContent = ({ tripCount, classes }: IProps) => {
  const { t } = useTranslation()
  return (
    <>
      <div>
        <span className={classes.text}>
          <strong>{`${t('trips.heatmap.trips_heatmap.trips_start_number_in_tile')} : `}</strong>
        </span>
        <span className={classes.text}>{tripCount}</span>
      </div>
    </>
  )
}

export default withStyles(styles)(OriginPopupContent)
